import { defineStore } from "pinia";
import config from '@/config'

const THEME_STORAGE_KEY = "mylimni_theme";

/** Thème mémorisé, s'il correspond à un thème réellement déclaré. */
function storedTheme(): string {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    // Les seuls thèmes déclarés dans plugins/vuetify.ts. Un nom inconnu
    // (l'ancien sélecteur écrivait 'dark'/'light') ne sélectionnait rien.
    if (saved === "BLUE_THEME" || saved === "DARK_BLUE_THEME") return saved;
  } catch {
    // localStorage indisponible (navigation privée, quota) : on garde le défaut.
  }
  return config.actTheme;
}

export const useCustomizerStore = defineStore("customizer",{

  state: () => ({
    Sidebar_drawer: config.Sidebar_drawer,
    mini_sidebar: config.mini_sidebar,
    setRTLLayout:config.setRTLLayout, // RTL layout
    actTheme: storedTheme(),
    boxed: config.boxed,
    setBorderCard: config.setBorderCard
  }),

  getters: {},
  actions: {
    SET_SIDEBAR_DRAWER() {
      this.Sidebar_drawer = !this.Sidebar_drawer;
    },
    SET_MINI_SIDEBAR(payload: boolean) {
      this.mini_sidebar = payload;
    },
    SET_THEME(payload: string) {
      this.actTheme = payload;
      // Persisté : le choix était perdu à chaque rechargement.
      try {
        localStorage.setItem(THEME_STORAGE_KEY, payload);
      } catch {
        // Sans stockage, le thème reste appliqué pour la session en cours.
      }
    },
    SET_CARD_BORDER(payload: boolean){
      this.setBorderCard = payload
    }
  },
});
